// Auto-generated normalizer for table: Perfiles
export function perfilesNormalize(row) {
  return {
    idPerfil: row.idPerfil ?? row.IdPerfil ?? row['IdPerfil'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
